module.exports = __webpack_public_path__ + "assets/img/banner.d5067e5d.jpg";